import { SharedState } from '@trello/shared-state';

interface ListComposerState {
  isOpen: boolean;
  position: number | null;
}

const defaultValue: ListComposerState = { isOpen: false, position: null };

export const listComposerState = new SharedState<ListComposerState>(
  defaultValue,
);

export const openListComposer = ({ position }: { position: number }) => {
  listComposerState.setValue({ isOpen: true, position });
};

export const closeListComposer = () => {
  listComposerState.setValue(defaultValue);
};
